/*
  CB 15/10/2026 (sera) - Nomi delle linee nel menu (desktop e mobile):
  "Neutra - Senza Profumo" -> "NEUTRA - senza profumo"; "Blu Sun" -> "BLU SUN";
  "Blu Products" -> "BLU PRODUCTS". Si riconoscono dal link alla collezione.
  Cambia solo il testo mostrato: la voce nel menu di Shopify resta com'e'.
  Regola: la parte prima di " - " va in maiuscolo, il resto in minuscolo.
  Per aggiungere una linea basta aggiungere il suo handle in HANDLES.

  CB 16/10/2026 - Menu mobile che a volte non si apriva.
  Il pannello del menu (header-drawer) si attiva insieme all'header; prima era a fine
  caricamento della pagina (misurato 9,7 s con connessione lenta), ora appena visibile
  (sections/header.liquid). Resta un breve istante in cui un tocco sull'hamburger
  andrebbe perso: qui il tocco viene ricordato e, appena il pannello e' pronto, il menu
  si apre (e il pulsante passa su "chiudi", cosi' il tocco successivo lo richiude).
  Due tocchi anticipati = apri + chiudi = nessuna apertura.
*/
(function () {
  var HANDLES = ['neutra-senza-profumo', 'blu-sun', 'blu-products']
  var SELECTOR = '.site-nav__dropdown-link, .slide-nav__link'

  function matches(href) {
    href = (href || '').split('?')[0].replace(/\/+$/, '')
    for (var i = 0; i < HANDLES.length; i++) {
      var tail = '/collections/' + HANDLES[i]
      if (href.slice(-tail.length) === tail) return true
    }
    return false
  }

  function transform(text) {
    var m = text.match(/^(\s*)([\s\S]*?)(\s*)$/)
    var core = m[2]
    if (!core) return text
    var i = core.indexOf(' - ')
    var out = i === -1 ? core.toUpperCase() : core.slice(0, i).toUpperCase() + core.slice(i).toLowerCase()
    return m[1] + out + m[3]
  }

  function run() {
    var links = document.querySelectorAll(SELECTOR)
    for (var i = 0; i < links.length; i++) {
      var a = links[i]
      if (!matches(a.getAttribute('href'))) continue
      var walker = document.createTreeWalker(a, NodeFilter.SHOW_TEXT)
      var node
      while ((node = walker.nextNode())) {
        if (!node.nodeValue.trim()) continue
        if (node.parentElement && node.parentElement.closest('.visually-hidden, .icon__fallback-text')) continue
        var next = transform(node.nodeValue)
        if (next !== node.nodeValue) node.nodeValue = next
      }
    }
  }

  // ---- menu mobile: tocco prima che il pannello sia pronto ----------------------
  var wantOpen = false
  var watching = false
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.mobile-nav-trigger') : null
    if (!btn) return
    var drawer = document.querySelector('header-drawer.site-header__mobile-nav')
    if (!drawer || !drawer.hasAttribute('defer-hydration')) return
    wantOpen = !wantOpen
    if (watching) return
    watching = true
    var mo = new MutationObserver(function () {
      if (drawer.hasAttribute('defer-hydration')) return
      mo.disconnect()
      watching = false
      setTimeout(function () {
        if (!wantOpen) return
        wantOpen = false
        if (drawer.classList.contains('is-active')) return
        btn.dispatchEvent(new CustomEvent('mobileNav:open', { bubbles: true }))
        btn.classList.add('is-active')
        var tm = btn.closest('toggle-menu')
        if (tm) tm.isMobileNavOpen = true
      }, 80)
    })
    mo.observe(drawer, { attributes: true, attributeFilter: ['defer-hydration'] })
  }, true)

  var pending = false
  function schedule() {
    if (pending) return
    pending = true
    setTimeout(function () { pending = false; run() }, 50)
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run)
  else run()
  new MutationObserver(schedule).observe(document.body || document.documentElement, { childList: true, subtree: true })
})()